Auth = require 'db/auth'
React = require 'react'
socialBlogUrls = require('locale').social.blog
t = require('views/internal/recup-with-helpers')('notifications-onboarding')
trackUe = require 'debug/trackUe'
_ = require 'underscore'
Util = require 'lib/util'

module.exports = class NotificationsOnBoarding extends React.Component
  displayName: 'NotificationsOnBoarding'

  _getBlogLink: ->
    # we have translated blog links we want to show for fr and pt-BR (show
    # the english blog for all other locales)
    locale = Auth.me().get('prefs').locale
    if locale == 'fr'
      socialBlogUrls + '/notifications-trello'
    else if locale == 'pt-BR'
      socialBlogUrls + '/notificacoes-trello'
    else
      socialBlogUrls + '/trello-notifications-mark-as-read'

  render: t.renderable ->
    blogLink = @_getBlogLink()
    t.div '.notifications-onboarding-dialog', ->

      t.span ->
        t.button '.hide-dialog-trigger.dialog-close-button.unstyled-button', {
          onClick: (e) ->
            Util.stop(e)
            Auth.me().dismiss('notifications-onboarding')
            trackUe(
              'header'
              'dismisses'
              'onboarding overlay'
              ''
              'over notifications menu'
              'by clicking the X button in onboarding overlay'
            )
          type: 'button'
        }, =>
          t.icon 'close'

      t.div '.notifications-onboarding-header', ->
        t.h1 ->
          t.format 'notifications-have-new-look'

      t.div '.notifications-onboarding-bullet', ->
        t.div '.left-side-graphic', ->
          t.img { src: require('images/notifications-onboarding/context_Illos.svg') }
        t.div '.right-side-message', ->
          t.h3 ->
            t.format 'get-context-header'
          t.p ->
            t.format 'get-context-content-see-all-action-with-grouping'

      t.div '.notifications-onboarding-bullet', ->
        t.div '.left-side-graphic', ->
          t.img { src: require('images/notifications-onboarding/action_Illos.svg') }
        t.div '.right-side-message', ->
          t.h3 ->
            t.format 'take-action-header'
          t.p ->
            t.format 'take-action-content-do-stuff-in-notification-panel'

      t.div '.notifications-onboarding-bullet', ->
        t.div '.left-side-graphic', ->
          t.img { src: require('images/notifications-onboarding/unread_Illos.svg') }
        t.div '.right-side-message', ->
          t.h3 ->
            t.format 'mark-unread-header'
          t.p ->
            t.format 'mark-unread-content-click-dot-to-mark-unread'

      t.div '.notifications-onboarding-bullet.last', ->
        t.div '.left-side-graphic', ->
          t.img { src: require('images/notifications-onboarding/Filter_Illos.svg') }
        t.div '.right-side-message', ->
          t.h3 ->
            t.format 'filter-by-unread-header'
          t.p ->
            t.format 'filter-by-unread-content-view-all-or-only-unread'

      t.div '.notifications-onboarding-footer', ->
        t.button '.view-notifications', {
          onClick: (e) ->
            Util.stop(e)
            Auth.me().dismiss('notifications-onboarding')
            trackUe(
              'header'
              'dismisses'
              'onboarding overlay'
              ''
              'over notifications menu'
              'by clicking the View Your Notifications button in onboarding overlay'
            )
        }, ->
          t.format 'button-view-your-notifications'
        t.a {
          target: '_blank',
          href: blogLink
        }, ->
          t.button '.learn-more',  {
            onClick: ->
              trackUe(
                'header'
                'opens'
                'blog'
                ''
                ''
                'by clicking the Learn More button in onboarding overlay'
              )
          }, ->
            t.format 'button-learn-more'



// WEBPACK FOOTER //
// ./app/scripts/views/notification/notifications-onboarding.coffee